import React, { useEffect } from 'react'
import useApp from 'hooks/useApp'
import { Button } from 'components'
import { Link, Navigate } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'


const InfluencerIntro = () => {

	const App = useApp()
	const navigate = useNavigate()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="flex_ 1 padding center-cont">
				<i className="icon icon_influencer_intro" />
				<h3 className="intro-tit mt_20">금융고수들의 생생한 금융 생활을<br />구독할 수 있어요!</h3>
				<p className="intro-sub-tit mt_10">
					금융인플루언서를 참여하고<br />
					내 자산을 타인에게 뽐내보아요!
				</p>
			</div>
			<div className="padding flex-shrink_0">
				{/* <Link to={"/home/influencer"}> */}
					<Button onClick={() => navigate(-1)} className="btn btn--big" >금융 인플루언서 보러가기</Button>
				{/* </Link> */}
			</div>
		</div>
	)
}

export default InfluencerIntro
